import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["maskProps"],
  _excluded2 = ["value", "name", "id", "disabled", "hasError", "placeholder", "onChange", "textAlign", "adornStart", "adornEnd", "css", "style", "className", "as", "asChild", "type", "maskProps"];
import React from "react";
import AdornmentWrapper from "./components/AdornmentWrapper";
import MaskedInput from "./components/Mask";
import { BaseInputWrapper, BaseTextInput } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var getInputComponent = function getInputComponent(_ref, forwardRef) {
  var maskProps = _ref.maskProps,
    restProps = _objectWithoutProperties(_ref, _excluded);
  if (maskProps) {
    return /*#__PURE__*/_jsx(MaskedInput, _extends({
      ref: forwardRef,
      maskProps: maskProps
    }, restProps));
  }
  return /*#__PURE__*/_jsx(BaseTextInput, _extends({}, restProps, {
    ref: forwardRef
  }));
};
var TextInput = /*#__PURE__*/React.forwardRef(function (_ref2, forwardedRef) {
  var value = _ref2.value,
    name = _ref2.name,
    id = _ref2.id,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    hasError = _ref2.hasError,
    placeholder = _ref2.placeholder,
    onChange = _ref2.onChange,
    textAlign = _ref2.textAlign,
    adornStart = _ref2.adornStart,
    adornEnd = _ref2.adornEnd,
    css = _ref2.css,
    style = _ref2.style,
    className = _ref2.className,
    as = _ref2.as,
    asChild = _ref2.asChild,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? "text" : _ref2$type,
    maskProps = _ref2.maskProps,
    restProps = _objectWithoutProperties(_ref2, _excluded2);
  var inputProps = _extends({
    id: id,
    name: name,
    type: type,
    disabled: disabled,
    value: value,
    textAlign: textAlign || "left",
    placeholder: placeholder,
    onChange: onChange,
    maskProps: maskProps
  }, restProps);
  var inputComponent = getInputComponent(inputProps, forwardedRef);
  return /*#__PURE__*/_jsxs(BaseInputWrapper, {
    hasError: hasError,
    disabled: disabled,
    children: [!!adornStart && /*#__PURE__*/_jsx(AdornmentWrapper, {
      adornmentProps: adornStart,
      side: "start"
    }), inputComponent, !!adornEnd && /*#__PURE__*/_jsx(AdornmentWrapper, {
      adornmentProps: adornEnd,
      side: "end"
    })]
  });
});
TextInput.displayName = "TextInput";
export default TextInput;